module.exports = __webpack_public_path__ + "img/43.ed2a139c.svg";